import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import BtnIcons from "../../api/images/btnIcons"
import * as XLSX from 'xlsx';
import PropTypes from 'prop-types';

/**
 * 엑셀 데이터 미리보기 모달
 * @param {Object} props 컴포넌트 속성
 * @param {boolean} props.open 모달 열림 상태
 * @param {Function} props.onClose 모달 닫았을 때
 * @param {File} props.file 엑셀 파일
 * @param {Function} props.onCancel 취소 클릭 시
 */
function ExcelPostModal({ open, onClose, file, onCancel }) {
    const [tableData, setTableData] = useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (file && open) {
            loadExcelData(file);
        }
    }, [file, open]);

    const loadExcelData = (file) => {
        setIsLoading(true);

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                // 첫 번째 시트 가져오기
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];

                // 시트 데이터를 JSON으로 변환
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                if (jsonData && jsonData.length > 0) {
                    // 첫 번째 행을 헤더로 사용
                    const headers = jsonData[0];
                    setTableHeaders(headers);

                    // 나머지 행은 데이터로 사용
                    const rows = jsonData.slice(1).map(row => {
                        const rowData = {};
                        headers.forEach((header, index) => {
                            rowData[header] = row[index] !== undefined ? row[index] : '-';
                        });
                        return rowData;
                    });

                    setTableData(rows);
                }
            } catch (error) {
                console.error('엑셀 데이터 파싱 중 오류가 발생했습니다.', error);
                setErrorMessage("엑셀 데이터 파싱 오류")
            } finally {
                setIsLoading(false);
            }
        };

        reader.onerror = () => {
            setIsLoading(false);
            console.error('파일을 읽는 중 오류가 발생했습니다.');
        };

        reader.readAsArrayBuffer(file);
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="modalBox">
                <div className="modalTitle">
                    엑셀 데이터 미리보기
                    <img
                        src={BtnIcons.closeIcon}
                        onClick={onClose}
                        style={{
                            cursor: 'pointer',
                            float: 'right',
                        }}
                        alt="closeIcon"
                    />
                </div>

                <div className="sectionLine" />
                <div className="spaceDiv10"/>

                <div
                    className="descText"
                    style={{
                        width: '100%',
                        height: 500,
                        overflow: 'auto',
                    }}
                >

                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>데이터를 불러오는 중...</div>
                    ) : (
                        <div className="table-container" style={{ width: "90vw", maxWidth: "90vw"}}>
                            {tableData && tableData.length > 0 ? (
                                <table >
                                    <thead>
                                    <tr>
                                        {tableHeaders.map((column, index) => (
                                            <th key={index}>
                                                {column}
                                            </th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {tableData.map((item, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {tableHeaders.map((header, colIndex) => (
                                                <td className={`td-${colIndex}`} key={colIndex}>
                                                    <div className={"td-item"}>
                                                        <div className={"td-text"}>
                                                            {typeof item[header] === 'string' && item[header].length > 100
                                                                ? `${item[header].substring(0, 100)}...`
                                                                : item[header] || '-'}
                                                        </div>

                                                    </div>

                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>

                            ) : (
                                <p className={"blueInfo"} style={{ textAlign: 'center', padding: '100px' }}>표시할 데이터가 존재하지 않습니다.</p>
                            )}
                        </div>
                    )}
                </div>

                <div className="sectionLine" />

                <div className="rightBtn padding">
                    <button className="outlineBtn" onClick={onCancel}>
                        취소
                    </button>
                    <button className="defaultBtn" onClick={onClose}>
                        확인
                    </button>
                </div>
            </Box>
        </Modal>
    );
}

ExcelPostModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    file: PropTypes.object,
    onCancel: PropTypes.func.isRequired
};

export default ExcelPostModal;